import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import firebase from "firebase/app";
import "firebase/firestore";
import axios from "axios";

import UUID from "vue-uuid";
import VueTheMask from "vue-the-mask";
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

Vue.use(VueTheMask);

Vue.use(UUID);

import Vue2Filters from "vue2-filters";

Vue.use(Vue2Filters);

const config = {
  apiKey: "AIzaSyBpFUN_o4Wltdz1FQzAgNTT5xuFc3WtEA0",
  authDomain: "smsbase-72fb1.firebaseapp.com",
  databaseURL: "https://smsbase-72fb1.firebaseio.com",
  projectId: "smsbase-72fb1",
  storageBucket: "smsbase-72fb1.appspot.com",
  messagingSenderId: "724529308056",
  appId: "1:724529308056:web:75c14b484f3eaff9",
};
firebase.initializeApp(config);
export const db = firebase.firestore();
//export const storage = firebase.storage();

Vue.config.productionTip = false;
Vue.prototype.$axios = axios;
const moment = require("moment");
require("moment/locale/da");

Vue.use(require("vue-moment"), {
  moment,
});

Vue.filter("initial", function(value) {
  if (value) {
    let first = value.charAt(0).toUpperCase();
    return first;
  }
});

Vue.filter("phoneNumber", function(str) {
  let cleaned = ("" + str).replace(/\D/g, "");

  //Check if the input is of correct length
  let match = cleaned.match(/^(\d{2})(\d{2})(\d{2})(\d{2})$/);

  if (match) {
    return match[1] + " " + match[2] + " " + match[3] + " " + match[4];
  }

  return null;
});

let app;

firebase.auth().onAuthStateChanged((user) => {
  if (user) {
    console.log("Logged in...");
  }
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      render: (h) => h(App),
    }).$mount("#app");
  }
});
